/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import { FaBuilding, FaNetworkWired } from "react-icons/fa";

import ContentCard from '../../../../../components/ui-elements/cards/ContentCard';
import BackButton from '../../../../../components/shared/Buttons/BackButton';


const ManageReportPage = () => {


    return (
        <>
            <Box m={6}>

                <Grid container spacing={4}  >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'View Reports'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-access" title="Access" subTitle="View Access" icon={<FaNetworkWired />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/view-splunk" title="Splunk" subTitle="View Splunk" icon={<FaBuilding />}></ContentCard>
                    </Grid>


                </Grid>

            </Box>

        </>
    )

}

export default ManageReportPage;
